import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  private baseUrl: string = environment.serviceUrl + environment.context;

  constructor(protected http: HttpClient) { }

  protected get(url: string): Observable<any> {
    let uri: string = this.baseUrl + url;
    console.log('URI', uri);
    return this.http.get(uri, this.getHeaders());
  }

  protected post(url: string, body: any): Observable<any> {
    let uri: string = this.baseUrl + url;
    return this.http.post(uri, body, this.getHeaders());
  }

  private getHeaders() {
    const httpOptions = { headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.getSessionToken()
      })
    };
    return httpOptions;
  }

  private getSessionToken(): string {
    let token: string = localStorage.getItem('sessionToken');
    return token;
  }
}
